// Error codes: https://gist.github.com/mlanett/a31c340b132ddefa9cca
// Translations (look for errors):
// https://app.lokalise.com/project/982792155ec5decea45825.37869004/?branch=master
// Testing: log in with (error_key)@anything.whatever and any password will do
export const parseError = (
  error: string,
  isResettingPassword = false,
  isOtpRequired = false
): string => {
  let translationKey = '';
  switch (error) {
    case 'unauthorized':
    case 'forbidden':
      if (isResettingPassword) {
        translationKey = 'resetting_password';
      } else if (isOtpRequired) {
        translationKey = 'invalid_otp';
      } else {
        translationKey = 'invalid_credentials';
      }
      break;
    case 'too_short':
    case 'too_long':
    case 'not_complex_enough':
    case 'not_different':
    case 'has_consecutive_chars':
    case 'already_used':
      translationKey = `password_${error}`;
      break;
    case 'password_expired':
    case 'password_expiring':
    case 'password_uninitialized':
    case 'login_failed':
    case 'last_attempt':
    case 'locked':
    case 'otp_required':
    case 'sso_required':
    case 'ip_restricted':
      translationKey = error;
      break;
    default:
      translationKey = 'authentication_service';
      break;
  }
  return `errors.${translationKey}`;
};
